import { ONGLET_CONTRAT, ONGLET_EMPLOYEUR, ONGLET_FORMATION } from '../shared'

export const OngletsDRF = [ONGLET_EMPLOYEUR, ONGLET_CONTRAT, ONGLET_FORMATION] as const
export type OngletDrf = (typeof OngletsDRF)[number]

export const OngletsDRFLibellés: Record<OngletDrf, string> = {
  Employeur: 'Employeur',
  Contrat: 'Contrat',
  Formation: 'Formation',
}
